import React, { useEffect, useState } from "react";
import { Button, Card, CardContent, Typography, Box } from "@mui/material";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import ErrorIcon from "@mui/icons-material/Error";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { getLocalStorageMenuItem, SARIconThemeColor, setLocalStorageMenuItem } from "../utility";
import { use } from "react";
import axios from "axios";

function OrderThanksScreen({ tableQr, tableName }) {
    const navigate = useNavigate();
    const queryString = window.location.search;
    const urlParam = new URLSearchParams(queryString);
    const success_flag = JSON.parse(urlParam.get("success"));
    const order_id = urlParam.get("order_id") || "";
    const token = getLocalStorageMenuItem("mobileLoginToken") || "";
    const [order_amount, setOrderAmount] = useState(0);

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {

                if (!order_id) {
                    console.error("Order ID is not provided");
                    return;
                }
                if (!token) {
                    console.error("Token is not available");
                    return;
                }

                const response = await axios.get(`${process.env.REACT_APP_API}/orders/${JSON.parse(order_id)}/details`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    if (response?.data?.success) {
                        setLocalStorageMenuItem("amount", response?.data?.data?.final_total || "0.00");
                        setOrderAmount(response?.data?.data?.final_total || "0.00");
                    } else {
                        console.error("Error in response data:", response?.data?.message || "Unknown error");
                        throw new Error(response?.data?.message || "Failed to fetch order details");
                    }
                } else {
                    console.error("Failed to fetch order details:", response);
                    throw new Error("Failed to fetch order details");
                }

                if (!response.status) {
                    throw new Error("Failed to fetch order details");
                }

            } catch (error) {
                console.error("Error fetching order details:", error);
            }
        }
        fetchOrderDetails();
    }, []);

    const amount = getLocalStorageMenuItem("amount") || "0.00";
    const currency = getLocalStorageMenuItem("currency") || "SAR";

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f4f4f4"
        >
            <Card sx={{
                width: "100%",
                height: "100vh",
                maxWidth: 500,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                boxShadow: 3,
                borderRadius: 3,
                p: 4,
            }}>
                {success_flag ? (
                    <>
                        <FastfoodIcon sx={{ fontSize: 100, color: "primary.main" }} />
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {t("Thank you for Choosing us!")}
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                {t("Your order has been placed successfully.")}
                            </Typography>
                            <Typography variant="h6" sx={{ mt: 2 }}>
                                {t("Amount Paid")} <br />
                                <strong>{order_amount || amount || "0.00"} {currency ? currency === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : currency : ""}</strong>
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 3 }}
                                onClick={() => navigate(`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`)}
                            >
                                {t("Continue")}
                            </Button>
                        </CardContent>
                    </>
                ) : (
                    <>
                        <ErrorIcon sx={{ fontSize: 100, color: "error.main" }} />
                        <CardContent>
                            <Typography variant="h6" gutterBottom color="error">
                                {t("Payment Failed")}
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                {t("Your payment was unsuccessful. Please try again or contact support.")}
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 3 }}
                                onClick={() => navigate(`/${tableName}/${tableQr}/cart?section=0&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`)}
                            >
                                {t("Try Again")}
                            </Button>
                        </CardContent>
                    </>
                )}
            </Card>
        </Box>
    );
}

export default OrderThanksScreen;
